module.exports = __webpack_public_path__ + "img/calibration.1c11395d.jpg";